import { PlusOutlined } from '@ant-design/icons';
import { Row, Col, Table, Tabs } from 'antd';
import { useEffect, useState } from "react";
import { Link } from 'react-router-dom';
import { ContentHeader } from "../../../components";
import { Links } from '../../../helpers/Links';
import { menuHelper } from '../../../helpers/account';
import Column from 'antd/es/table/Column';
import { hideLoadingScreen, showLoadingScreen } from '../../../store/reducers/loading';
import { useDispatch } from 'react-redux';
import { Tag } from 'antd/lib';
import { PhuCapTGV } from '../../../models/luong/PhuCapTGV';
import { layDsThuLaoKCT } from '../../../services/thulaokhongchuyentrach';

const DanhSachThuLaoKCT = () => {

    const menu: any = menuHelper.checkMultiPermission([Links.ThuLaoKhongChuyenTrach.ChiTiet]);
    const [danhsach, setDanhSach] = useState<Array<PhuCapTGV>>();
    const dispatch = useDispatch();

    const timkiem = async () => {
        try {
            dispatch(showLoadingScreen());
            const data = await layDsThuLaoKCT();
            setDanhSach(data);
        }
        catch (error: any) {
        };

        dispatch(hideLoadingScreen());
    }

    useEffect(() => {
        timkiem();
    }, []);

    return (<section>
        <ContentHeader title="Thù lao hội đồng quản lý không chuyên trách" />
        {
            menu[Links.ThuLaoKhongChuyenTrach.ChiTiet] ?
                <Row className="form-group" gutter={8}>
                    <Col span={24}>
                        {
                            <Link to={Links.ThuLaoKhongChuyenTrach.ChiTiet} className="hrm-btn float-right hrm-btn-warning" ><PlusOutlined className='align-self-center' rev="" />Thêm mới</Link>
                        }
                    </Col>
                </Row> : null
        }
        <div className="card card-primary">
            <Row>
                <Col span={24}>
                    <Table
                        locale={{ emptyText: "Không có dữ liệu" }}
                        dataSource={(danhsach || []).map((item: any, index) => { item.key = index; return item; })}
                    >
                        <Column title="Năm" dataIndex="nam" key="nam" />
                        <Column title="Tên kỳ quyết toán" key="ten" dataIndex="ten" />
                        <Column title="Loại thù lao" dataIndex="loaiThuLao" key="loaiThuLao"
                            render={(value: any, record: any) => {
                                switch (value) {
                                    case 0: return <Tag color="processing">Thù lao Quý(cách tính cũ)</Tag>;
                                    case 1: return <Tag color="cyan">Điều chỉnh/Bổ sung</Tag>;
                                    case 2: return <Tag color="success">Quyết toán</Tag>
                                    case 3: return <Tag color="warning">Tạm ứng</Tag>
                                }

                                return <Tag color="default">--</Tag>
                            }}
                        />
                        <Column title="Trạng thái" dataIndex="trangThai" key="trangThai"
                            render={(value: any, record: any) => {
                                switch (value) {
                                    case 0: return <Tag color="processing">Khởi tạo</Tag>;
                                    case 1: return <Tag color="success">Đã xác nhận</Tag>;
                                    case 2: return <Tag color="warning">Trình duyệt</Tag>
                                }

                                return <Tag color="default">--</Tag>
                            }}
                        />
                        {
                            menu[Links.ThuLaoKhongChuyenTrach.ChiTiet] &&
                            <Column
                                title=""
                                key="action"
                                render={(value, record, index) =>
                                (
                                    <Link key={"link" + index} className="hrm-btn hrm-btn-sm btn-primary" to={`${Links.ThuLaoKhongChuyenTrach.ChiTiet}?id=${value?.id}`}>Xem</Link>
                                )
                                }
                            />
                        }
                    </Table>
                </Col>
            </Row>
        </div>
    </section>
    );
};

export default DanhSachThuLaoKCT;
